import { createClient } from '@supabase/supabase-js';

const baseUrl: string = process.env.NEXT_PUBLIC_SUPABASE_URL || '';
const anonKey: string = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || '';
const options: any = {};

export const supabase = createClient(baseUrl, anonKey, options);
